<script>
  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();

  import SimpleAutocompleteDropdown from "./Autocomplete/SimpleAutocompleteDropdown.svelte";
  import TagInputAutocomplete from "./Autocomplete/TagInputAutocomplete.svelte";
  import apiutil from "./Autocomplete/api_util.js";

  export let value = null; //initial data
  export let text = ""; //initial display data for non list mode
  export let placeholder;
  export let dropdownItemTemplateCB = null;
  export let dropdownItemTemplateComponent = null;
  export let listMode = false;
  export let disabled = false;
  export let objectType;
  export let apiParams = null;
  export let searchUrlInput;
  export let addFromAutocompleteOnly = null;
  export let inputId = null;
  export let inputErrors = null;
  export let displayTags = true;
  export let dropdownClassName = "";
  export let showSimpleAutocompleteCloseIcon = false;
  export let preSelectedOptions = [];
  export let field = undefined;
  export let closeDropdown = undefined;
  export let clickedIntoInput = null;
  export let leftInput = null;
  export let showResultsWithoutFocus = false;

  var scope = getScope();

  function getScope() {
    return apiutil.prepare({
      objectType: objectType,
      apiParams: apiParams,
      searchUrlInput: searchUrlInput,
      listMode: listMode,
    });
  }

  let apiHandler = async function (input) {
    return apiutil.searchAPI(scope, input);
  };

  const forwardEvent = e => {
    dispatch(e.type, e.detail);
  };

  $: {
    searchUrlInput;
    scope = getScope();
  }
</script>

<div class="autocomplete full-width show-overflow">
  {#if listMode}
    <TagInputAutocomplete
      {preSelectedOptions}
      {apiHandler}
      bind:value
      {placeholder}
      {inputId}
      {addFromAutocompleteOnly}
      bind:disabled
      on:focus={forwardEvent}
      on:tagAdded={forwardEvent}
      on:tagRemoved={forwardEvent}
      on:keyenter={forwardEvent}
      dropdownItemTemplateCB={dropdownItemTemplateCB || scope.widget.dropdownItemTemplateCB}
      {dropdownItemTemplateComponent}
      {displayTags}
      {dropdownClassName}
      {inputErrors}
      let:text
      autoCompleteKey={field}
      bind:clickedIntoInput
      bind:leftInput
    >
      <slot slot="dropdown-header" name="dropdown-header" {text} />
      <slot slot="dropdown-footer" name="dropdown-footer" {text} />
    </TagInputAutocomplete>
  {:else}
    <SimpleAutocompleteDropdown
      {apiHandler}
      {placeholder}
      {text}
      {addFromAutocompleteOnly}
      dropdownItemTemplateCB={dropdownItemTemplateCB || scope.widget.dropdownItemTemplateCB}
      {inputId}
      showInputWhenDisabled={true}
      on:clear={forwardEvent}
      on:change={forwardEvent}
      bind:value
      {disabled}
      on:select
      showCloseIcon={showSimpleAutocompleteCloseIcon}
      {field}
      let:text
      bind:closeAfterSelect={closeDropdown}
      bind:clickedIntoInput
      bind:leftInput
      {showResultsWithoutFocus}
    >
      <slot slot="no_results" name="no_results" {text} />
      <slot slot="default" {text} />
    </SimpleAutocompleteDropdown>
  {/if}
</div>
